import { useAuth } from "@lib/auth/useAuth";
import dynamic from "next/dynamic";

const MicrosoftLiveChatWrapper = dynamic(() => import("./microsoftLiveChatScript"), {
    ssr: false,
});

const SalesforceLiveChatScript = dynamic(() => import("./SalesforceLiveChatScript"), {
    ssr: false,
});

export const LiveChatScript = ({ shouldDisplayLiveChat = true }) => {
    const { isAuthenticated } = useAuth();
    const chatSolution = process.env.NEXT_PUBLIC_LIVE_CHAT_SOLUTION || "";

    if (chatSolution === "D365") {
        return (
            <MicrosoftLiveChatWrapper
                isAuthenticated={isAuthenticated}
                shouldDisplayLiveChat={shouldDisplayLiveChat}
            />
        );
    } else {
        return <SalesforceLiveChatScript />;
    }
};

export default LiveChatScript;
